<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
<template>
  <div class="setMaster" style="height: 100vh; overflow: auto">
    <h1 class="center" style="margin: 15px;">{{ $translation[$location]['button']['help'] }}</h1>
    <v-row>
      <v-col
        v-for="help in $helps"
        :key="'help:' + help.id"
        style="padding: 10px; padding-bottom: 15px"
        cols="12"
        lg="3"
        md="3"
        sm="3"
      >
        <v-card class="center" style="padding: 20px; padding-bottom: 30px">
          <h2 style="padding-bottom: 10px;">{{ help.title.toUpperCase() }}</h2>
          <h4 style="text-align: justify;height: 150px; overflow: auto; ">{{ help.text }}</h4>
        </v-card>
      </v-col>
    </v-row>
    <br v-for="space in 5" :key="'spaceOnline' + space" />
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    data: { type: Array },
  },
  data() {
    return {};
  },
  mounted() {},

  created() {
    //this.formTeacher.email = localStorage.getItem("teacherEmailMatras");
  },
  computed: {},
  methods: {
    submit() {},
  },
  continuar() {},
  close() {},
};
</script>
<style scoped>
.setMaster * {
  padding: 2px;
  margin: 0.5px;
  justify-content: center;
}
.set1 * {
  text-align: justify;
  align-items: center;
}
</style>
